import { render, staticRenderFns } from "./SelectBoxOtherInput.vue?vue&type=template&id=0fa75628&"
import script from "./SelectBoxOtherInput.vue?vue&type=script&lang=js&"
export * from "./SelectBoxOtherInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports